var path = '/E106CompliancePropertyInformation/'

function get (http, id) {
    return http.get(`${path}Get?id=${id}`)
}

function put (http, dto) {
    return http.put(path, dto)
}

function remove (http, id) {
    return http.post(`${path}Remove?id=${id}`)
}

function search (http, complianceId) {
    return http.post(`${path}Search?complianceId=${complianceId}`)
}

export default {
    get: get,
    put: put,
    remove: remove,
    search: search
}



// WEBPACK FOOTER //
// ./src/services/e106CompliancePropertyInformationService.js